import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgCircleExclamationSolid = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12 21a9 9 0 0 0 9-9 9 9 0 0 0-9-9 9 9 0 0 0-9 9 9 9 0 0 0 9 9m0-13.5c.468 0 .844.376.844.844v3.937a.84.84 0 0 1-.844.844.84.84 0 0 1-.844-.844V8.344c0-.468.376-.844.844-.844m1.125 7.875c0 .622-.503 1.125-1.125 1.125a1.124 1.124 0 0 1-1.125-1.125c0-.622.503-1.125 1.125-1.125s1.125.503 1.125 1.125"
    }));
export default SvgCircleExclamationSolid;
